import PropTypes from 'prop-types';
import React from 'react';
import { Box, Flex, Heading, Image } from 'roo-ui/components';

const Card = ({ imageAltText, imageSrc, title, children, ...props }) => (
  <Box width={[1, 0.4]} mr={[0, 16]} {...props}>
    <Flex alignItems="center" mb={4}>
      <Image alt={imageAltText} src={imageSrc} data-testid="image" />
      <Heading.h3 mb={0} ml={5} data-testid="heading">
        {title}
      </Heading.h3>
    </Flex>
    {children}
  </Box>
);

Card.propTypes = {
  children: PropTypes.node,
  imageAltText: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

Card.defaultProps = {
  children: null,
};

export default Card;
